import { makeReadableName } from "@/shared/utils/common.utils";

/**
 * @description
 * * ADMIN - can see all assessments, reports, etc. can create new assessments.
 * * ASSESSMENT_TEAM_MEMBER - can't create assessments, can only see assessments they're part of.
 * */
export enum ClientRoleEnum {
  ADMIN = "admin",
  ASSESSMENT_MANAGER = "assessment_manager",
  ASSESSMENT_TEAM_MEMBER = "assessment_team_member",
}

export const ClientRoleDescriptions = {
  [ClientRoleEnum.ADMIN]:
    "can invite other users, change user roles, view all assessments, invite candidates to all assessments, and view reports for all assessments.",
  [ClientRoleEnum.ASSESSMENT_MANAGER]:
    "can view all assessments, invite candidates to all assessments, and view reports for all assessments. They are unable to invite others to the platform or change user roles.",
  [ClientRoleEnum.ASSESSMENT_TEAM_MEMBER]:
    "can be assigned to specific assessments from the Settings tab within an assessment, and given a sub-role to define their level of access and responsibilities for that assessment.",
};

export const clientRoleDefinitions = Object.values(ClientRoleEnum).map((role) => ({
  name: makeReadableName(role),
  description: ClientRoleDescriptions[role],
}));
